"use client";
import { useEffect, useReducer } from "react";
var MAX_DELAY_MS = 24 * 60 * 60 * 1000;
export function getRerenderDelay(time, now) {
    if (now === void 0) { now = Date.now(); }
    return Math.min(Math.max(time - now + 1000, 0), MAX_DELAY_MS);
}
export function useRerenderAt(at) {
    var _a;
    var _b = useReducer(function (tick) { return tick + 1; }, 0), rerender = _b[1];
    var time = (_a = at === null || at === void 0 ? void 0 : at.getTime()) !== null && _a !== void 0 ? _a : null;
    useEffect(function () {
        if (time === null) {
            return;
        }
        var timer;
        var schedule = function () {
            var delay = getRerenderDelay(time);
            if (delay === 0) {
                timer = setTimeout(rerender, 0);
                return;
            }
            timer = setTimeout(schedule, Math.min(delay, MAX_DELAY_MS));
        };
        schedule();
        return function () { return clearTimeout(timer); };
    }, [time]);
}
//# sourceMappingURL=use-rerender-at.js.map